module.exports = __webpack_public_path__ + "img/17_sp.537c01d2.gif";